import { render, staticRenderFns } from "./HealthCardInput.vue?vue&type=template&id=74cabf77"
import script from "./HealthCardInput.vue?vue&type=script&lang=js"
export * from "./HealthCardInput.vue?vue&type=script&lang=js"
import style0 from "./HealthCardInput.vue?vue&type=style&index=0&id=74cabf77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports